import { param } from "express/lib/request"
import { get, post, bmsget, bmsPost } from "./http"

// 根据token获取用户信息
export const getUserInfo = params => get('user/index', params)

// 获取微信的一些参数
export const getSomeWxInfo = params => post('index/index', params)

// 获取省
export const getProvinceList = params => get('store/region', params)

// 获取市
export const getCityList = params => get('store/region', params)

// 获取区
export const getAreaList = params => get('store/region', params)

// 根据省市区名字获取id
export const getIdByName = params => get('appointment/get_region', params)

// 获取短信验证码
export const getSmsCode = params => get('appointment/send_msg', params)

// 活动页提交
export const activeApply = params => post('appointment/add_appointment', params)

// 获取uuid
export const getuuid = params => bmsget('v1/wj/uuid', params)

// 期望表单提交
export const expectationSubmit = params => bmsPost('v1/wj/answer', params)



// WEBPACK FOOTER //
// ./src/request/api.js